import { useContext } from "react";

import { ApiContext, IApiContext } from "./ApiContext";

export function useApi(): IApiContext {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within a ApiProvider");
  }

  return context;
}
